import {
  AngleDown,
  ChakraBox,
  ChakraText,
  EquipUITheme,
  Menu,
  MenuOption,
  Modal,
} from '@equip.health/ui';

import DialogActionButton from '~/components/common/DialogActionButton';

const { h6, label } = EquipUITheme.typography;

const TOP_LEVEL_ID = 'warning-modal';

export type WarningModalSize =
  | 'sm'
  | 'md'
  | 'lg'
  | 'xl'
  | '2xl'
  | 'xs'
  | '3xl'
  | '4xl'
  | '5xl'
  | '6xl'
  | 'full';

type WarningModalProps = {
  cancelButtonText?: string;
  confirmButtonText: string;
  description: string;
  enableGrouping?: boolean;
  id: string;
  isDisabled?: boolean;
  isLoading?: boolean;
  isOpen: boolean;
  menuLabel?: string;
  menuListZIndex?: number;
  modalSize?: WarningModalSize;
  modalType?: string;
  onClickCancel: () => void;
  onClickConfirm: () => void;
  onClose: () => void;
  setVoidReason?: (val: string) => void;
  title: string;
  voidReason?: string;
  voidReasons?: MenuOption[];
};

/**
 * @deprecated Use ConfirmModal or DiscardChangesModalV2 instead. Will be removed with GX-3704.
 */
const WarningModal = ({
  cancelButtonText = 'Cancel',
  confirmButtonText,
  description,
  enableGrouping = false,
  id,
  isDisabled,
  isLoading,
  isOpen,
  menuLabel = 'Void reason',
  menuListZIndex = 100,
  modalSize = 'xs',
  modalType,
  onClickCancel,
  onClickConfirm,
  onClose,
  setVoidReason,
  title,
  voidReason,
  voidReasons,
}: WarningModalProps) => (
  <Modal
    footerContent={
      <>
        <DialogActionButton
          handleClick={onClickCancel}
          text={cancelButtonText}
          variant="ghost"
        />
        <DialogActionButton
          handleClick={onClickConfirm}
          isDisabled={isDisabled}
          isLoading={isLoading}
          text={confirmButtonText}
          variant="solid"
        />
      </>
    }
    id={TOP_LEVEL_ID}
    isOpen={isOpen}
    onClose={onClose}
    size={modalSize}
    title={<ChakraText {...h6}>{title}</ChakraText>}
  >
    <ChakraText {...label} color="neutral.secondary" padding="4px 0px 12px">
      {description}
    </ChakraText>
    {modalType === 'Void' && (
      <ChakraBox margin="8px 0px 8px -5px">
        <Menu
          backgroundColor="neutral.background.secondary"
          border="none"
          borderRadius="20px"
          buttonContent={
            voidReasons.find(({ value }) => value === voidReason)?.node
          }
          buttonHeight="50px"
          buttonVariant="ghost"
          color="neutral.secondary"
          enableGrouping={enableGrouping}
          fontSize="14px"
          fontWeight="normal"
          formMarginBottom="28px"
          height="48px"
          icon={<AngleDown fill="teal" height="15px" width="15px" />}
          id={`${id}_${TOP_LEVEL_ID}`}
          isRequired
          label={menuLabel}
          listMaxHeight="250"
          menuListZIndex={menuListZIndex}
          menuWidth="100%"
          onSelect={(val) => setVoidReason(val)}
          options={voidReasons}
          overflow="scroll"
          placeholder="Select..."
          textAlign="left"
          wrapMenuListInPortal
        />
      </ChakraBox>
    )}
  </Modal>
);

export default WarningModal;
